import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-51" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-52" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-53" data-mp="32m1bayt2r0om">
          SIGMA SMART<span className="align-super text-xs" data-id="element-54" data-mp="36ppk1ktg02bg">™</span> — MÉTHODE REHAB 360<span className="align-super text-xs" data-id="element-55" data-mp="3uesc7mlpddk7">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-56" data-mp="38qu4u3bljp2">
          🏥 “Votre premier protocole commence aujourd'hui.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-57" data-mp="3ldu3ir0bkhva">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-58" data-mp="3qblyjtw9gk3p">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-59" data-mp="2eyjpdjwhqwtk" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-60" data-mp="3l8qwa43iojrg">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-61" data-mp="3gbqx8d534h9u" /> @sigmasmart.french
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-62" data-mp="3v9b09eif82dd">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-63" data-mp="3q726wh1myyaq">
            Conditions générales
          </a>
          <span data-id="element-64" data-mp="33xc3sjqnopv">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-65" data-mp="34pa1a0t5yjb">
            Politique de confidentialité
          </a>
          <span data-id="element-66" data-mp="hs1wd0yfw8ar">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-67" data-mp="ctqnotjvs3u4">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-68" data-mp="qujmhqh7tl31">
          © 2026 SIGMA SMART™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}